import React from 'react';
import {
  FaHome,
  FaUsers,
  FaHandshake,
  FaCogs,
  FaWarehouse,
  FaBullhorn,
  FaBuilding,
  FaAddressCard,
  FaClipboard,
  FaTshirt,
  FaCube,
  FaPalette,
  FaReceipt,
  FaFileInvoice,
  FaHammer,
  FaBriefcase,
  FaFlask,
  FaEnvelope,
  FaStar,
  FaBoxes,
  FaShippingFast,
  FaInbox,
  FaArrowUp,
  FaQuestionCircle,
} from 'react-icons/fa';

// Icon mapping for navigation items
export const navigationIcons = {
  // Main category icons
  FaHome,
  FaUsers,
  FaHandshake,
  FaCogs,
  FaWarehouse,
  FaBullhorn,

  // Sub-item icons (if needed)
  FaBuilding,
  FaAddressCard,
  FaClipboard,
  FaTshirt,
  FaCube,
  FaPalette,
  FaReceipt,
  FaFileInvoice,
  FaHammer,
  FaBriefcase,
  FaFlask,
  FaEnvelope,
  FaStar,
  FaBoxes,
  FaShippingFast,
  FaInbox,
  FaArrowUp,
  FaQuestionCircle,
};

interface NavigationIconProps {
  iconName: string;
  size?: number;
  color?: string;
  className?: string;
}

export const NavigationIcon: React.FC<NavigationIconProps> = ({
  iconName,
  size = 20,
  color,
  className,
}) => {
  const IconComponent = navigationIcons[iconName as keyof typeof navigationIcons] || FaQuestionCircle;

  return (
    <IconComponent
      size={size}
      color={color}
      className={className}
    />
  );
};
